import { countDays } from '@shared/fondof-fn/date/count'

export const addDaysAndExcludeSundays = (
  startingDate: Date,
  daysFromStartingDate: number
) => {
  const sundays = countDays(
    startingDate,
    addDays(startingDate, daysFromStartingDate),
    0
  )

  return addDays(startingDate, daysFromStartingDate + sundays)
}

export const addDays = (date: Date, days: number) => {
  const newDate = new Date(date)
  newDate.setDate(newDate.getDate() + days)
  return newDate
}
